module.exports = __webpack_public_path__ + "img/img_left_nav_realtime_hover.6d630f4a.svg";